import { render } from "./PWAFeatures.vue?vue&type=template&id=2f7eb147&scoped=true"
import script from "./PWAFeatures.vue?vue&type=script&lang=js"
export * from "./PWAFeatures.vue?vue&type=script&lang=js"

import "./PWAFeatures.vue?vue&type=style&index=0&id=2f7eb147&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7eb147"]])

export default __exports__